import { types } from 'mobx-state-tree';

export const RowModel = types.model('RowModel', {
  identification: types.string,
  modificationDate: types.string
});
